import { Flex, Select, SelectProps, Spin } from 'antd';
import { useTranslation } from 'react-i18next';
import './style.scss';

type MultiSelectProps = SelectProps & {
  label: React.ReactNode;
};

const MultiSelect = ({
  label,
  value,
  onChange,
  style,
  loading,
  ...props
}: MultiSelectProps) => {
  const { t } = useTranslation();

  const handleSelect: SelectProps['onSelect'] = (selectedValue, option) => {
    if (value) {
      onChange?.([...value, selectedValue], option);
    }
  };

  const handleDeSelect: SelectProps['onDeselect'] = (
    deSelectedValue,
    option,
  ) => {
    onChange?.(
      value.filter((value: unknown) => value !== deSelectedValue),
      option,
    );
  };

  return (
    <div>
      <div className="label">{label}</div>
      <Select
        className="multi-select"
        mode="multiple"
        placeholder={t('genericForm.select', {
          value: label,
        })}
        maxTagCount="responsive"
        optionFilterProp="label"
        onChange={onChange}
        style={{
          minWidth: 200,
          width: '100%',
          ...style,
        }}
        loading={loading}
        notFoundContent={
          loading ? (
            <Flex justify="center" align="center">
              <Spin />
            </Flex>
          ) : undefined
        }
        onSelect={handleSelect}
        onDeselect={handleDeSelect}
        value={value}
        {...props}
      />
    </div>
  );
};

export default MultiSelect;
